import { ColDef, ColGroupDef } from '@ag-grid-community/core';

import { TableConstants } from '@shared/constants/table.constants';

import { getCostColumns } from './site-cost-summary-table-cost-config';
import {
  AgVisitHeaderComponent,
  AgVisitHeaderComponentParams,
} from '../components/ag-visit-header.component';
import { SiteSummaryGridContext } from '../types/site-summary-grid-context';
import { SiteSummaryGridRow } from '../types/site-summary-grid-row';

export const siteCostSummaryTablePatientVisitsConfig = (
  ctx: SiteSummaryGridContext
): ColGroupDef<SiteSummaryGridRow> => {
  return {
    children: getVisitCostColumns(ctx, ctx.aggregateColumns),
    headerClass: [TableConstants.STYLE_CLASSES.HEADER_ALIGN_CENTER, 'text-center', 'text-wrap'],
    headerName: 'Description',
  };
};

const getVisitCostColumns = (
  ctx: SiteSummaryGridContext,
  visits: SiteSummaryGridContext['aggregateColumns']
): ColDef<SiteSummaryGridRow>[] => {
  return visits.map((visit) => ({
    ...getCostColumns(ctx, 'visitCosts', visit.field),
    headerClass: 'ag-gray-header',
    headerComponent: AgVisitHeaderComponent,
    headerComponentParams: <AgVisitHeaderComponentParams>{
      visit,
    },
    initialWidth: 200,
  }));
};
